// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"App_wrapper__128h"};


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 574
// module chunks = 0